/*jshint esversion: 6 */
/*jshint strict: false */

import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
import "photoswipe/dist/photoswipe.css";

const lightbox = new PhotoSwipeLightbox({
	// may select multiple "galleries"
	gallery: '.pswp-gallery',

	// Elements within gallery (slides)
	children: '.pswp-gallery__item',

	// setup PhotoSwipe Core dynamic import
	pswpModule: PhotoSwipe
});
lightbox.init();
